const colors = require('./colors');
const typography = require('./typography');
const breakpoints = require('./breakpoints');
const motion = require('./motion');

module.exports = { colors, typography, breakpoints, motion };
